<template>
    <div class="add-video-modal action-video">
        <div class="add-video-block">
            <el-input  placeholder="Название" :disabled="blockNameField" size="small" v-model="form.name"></el-input>
            <el-input :disabled="blockUrlField" placeholder="URL" v-model="form.url" size="small">
                <template slot="prepend">Https://</template>
            </el-input>
            <el-button :disabled="blockSubmit" v-if="componentData" type="primary" size="small" @click="onSubmit('edit')">Сохранить</el-button>
            <el-button :disabled="blockSubmit" v-if="!componentData" type="primary" size="small" @click="onSubmit('add')">Добавить</el-button>
            <el-button size="small" @click="cancelChange(componentData)">Отмена</el-button>
        </div>
        <div class="tree-block">
            <tree-item class="discipline-item" :item="videosObj"/>
        </div>
    </div>
</template>

<script>

import { mapMutations } from 'vuex'
export default {
    data() {
        return {
            form: {
                name: '',
                url: '',
            },
            videosObj:{
              id:0,
              execution:'video-tree',
              level:0,
              lable: this.title,
              children: [],
              path: 'content',
              type:'directory',
              videos: [],
              webinars: []
          },
          urls:{
              video:{
                  add: `api/disciplines/${this.$route.params.did}/videos`,
                  edit: `api/disciplines/${this.$route.params.did}/videos/${this.componentData ? this.componentData.id: null}`
              },
              vebinar:{
                  add: `api/disciplines/${this.$route.params.did}/webinars`,
                  edit: `api/disciplines/${this.$route.params.did}/webinars/${this.componentData ? this.componentData.id: null}`
              }
          }
        }
    },
    props:{
        componentData: Object,
        title: String
    },
    components:{
        'tree-item':() => import('../viewingDiscipline/itemTree'),
    },
    computed:{
        mobileMode(){
            return this.$store.state.mobileMode
        },
        actualUrlGroup(){
            return this.title === "Видео" ? this.urls.video : this.urls.vebinar
        },
        
        pathTest(){
            if(this.selectedItem){
                return this.selectedItem.path
            }else{
                return ''
            }
        },
        showMenu(){
           return this.$store.state.viewingDiscipline.selectedItem
        },
        blockSubmit(){
            return this.form.name && (this.form.url || this.selectedItem) ? false : true
        },
        selectedItem(){
            return this.$store.state.viewingDiscipline.selectedItem
        },
        blockUrlField(){
            return this.selectedItem ? true : false
        },
        blockNameField(){
            return this.componentData ? true : false
        }

    },
    methods: {
        ...mapMutations(['setSelectedItem', 'updateVideoTree', 'updateWebinarTree']),
        clearFields(item){
            for (var key in item) {
                item[key]=''
            }
        },
        cancelChange(data){
            if(data){
                this.form.name = data.name ? data.name : data.theme
                this.form.url = data.url
                this.setSelectedItem(null)
            }else{
                this.form.name = data.name
                this.form.url = data.url
                this.setSelectedItem(null)
            }
        },
        onSubmit(flag) {
            let obj={name:this.form.name}
            if(this.selectedItem){
                obj.path = this.selectedItem.path
            }else{
                if(!this.checkURl(this.form.url)){
                    return this.notify(false, 'Указанная ссылка некорректна')
                }else{
                    obj.url = this.form.url
                }
            }
            flag === 'add' ? this.addVideo(obj) : this.editVideo(obj) 
        },
        editVideo(obj){
            this.axios.patch(this.actualUrlGroup.edit, obj)
            .then(res=>{
                if(res.data.status){
                    this.form.url = this.title==='Видео' ? res.data.video.url  : res.data.webinar.url
                    this.title==='Видео' ? this.updateVideoTree(res.data.videoMap) : this.updateWebinarTree(res.data.webinarMap)
                    this.setSelectedItem(null)
                }
                this.notify(res.data.status, res.data.message)
            })
        },
        addVideo(obj){
            this.axios.post(this.actualUrlGroup.add, obj)
            .then(res=>{
                if(res.data.status){
                    this.clearFields(this.form)
                    this.title==='Видео' ? this.updateVideoTree(res.data.videoMap) : this.updateWebinarTree(res.data.webinarMap)
                    
                    this.setSelectedItem(null)
                }
                this.notify(res.data.status, res.data.message)
            })
        },
        checkURl(value){
            let re = /^((ftp|http|https):\/\/)?(www\.)?([A-Za-zА-Яа-я0-9]{1}[A-Za-zА-Яа-я0-9\-]*\.?)*\.{1}[A-Za-zА-Яа-я0-9-]{2,8}(\/([\w#!:.?+=&%@!\-\/])*)?/;
            let reResult = re.test(value)
            return reResult
        },
        notify(status, text){
            const h = this.$createElement
            this.$notify({
                title: '',
                message: h('i', { style: `color: ${status ?  '#67C23A' : ' #f56c6c' }` }, text)
            });
        }
    },
    mounted() {
        this.axios.get(`api/disciplines/${this.$route.params.did}/v-store`)
            .then(res=>{
                this.videosObj.children = res.data.menu
            })
        if(this.componentData){
            this.form.url = this.componentData.url
            this.form.name = this.componentData.name ? this.componentData.name : this.componentData.theme
            
        }
    },
    beforeDestroy(){
        this.setSelectedItem(null)
    }
}
</script>

<style lang="scss">
    .action-video{
        height: 93%;
        display: grid;
        grid-template-rows: min-content auto;
        row-gap: 20px;
        overflow-y: auto;
        .add-video-block{
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            gap: 10px;
        }
        .el-input{
            max-width: 300px;
        }
        .tree-block{
            width: max-content;
            overflow-y: auto;
        }
        .el-button+.el-button{
            margin: 0;
        }
    }
    .add-video-modal{
        list-style: none;
        
        .button-wrp{
            display: flex;
            justify-content: center;
        }
    }
    @media (max-width: 800px){
        .action-video{
            .el-input{
                max-width: 100%;
            }
        }
    }
    @media (max-width: 400px){
        .el-col{
            margin-bottom: 15px;
        }
    }
</style>